<template>
  <base-widget>
    <template #widget-header>
      <base-widget-header>
        <template #header>
          <h3 class="widget-caption">Friends activity</h3>
        </template>
      </base-widget-header>
    </template>
    <template #widget-body>
      <base-widget-body mode="widget-body bordered-top bordered-sky">
        <template #body>
          <base-widget-card>
            <template #card>
              <base-widget-list>
                <template #list>
                  <friend-activity-item></friend-activity-item>
                </template>
              </base-widget-list>
            </template>
          </base-widget-card>
        </template>
      </base-widget-body>
    </template>
  </base-widget>
</template>

<script>
import FriendActivityItem from "@/components/FriendActivityItem.vue";
export default {
  components: {
    FriendActivityItem
  },
};
</script>